import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ec16bff0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bottom-border-box" }
const _hoisted_2 = { class: "info-box" }
const _hoisted_3 = {
  key: 0,
  class: "top-item"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon icon-zhiding",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-zhiding" })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, " 置顶 ", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "line"
}

import {computed} from 'vue';
import {Image} from 'vant';
import {publishTimeFormat} from '@/utils/timeFormat';
import {resizeImg} from '@/utils/handleImg';


const __default__ = {
  name: 'Item'
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    itemInfo: null,
    isTop: { type: Boolean },
    noBorder: { type: Boolean },
    toDetail: null
  },
  setup(__props: any) {

const props = __props as {
  itemInfo: InfoItem;
  isTop?: boolean;
  noBorder?: boolean;
  toDetail:(infoId: number, role: number) => void;
}

_useCssVars(_ctx => ({
  "381cdbe6": (_unref(itemBorder))
}))



const itemBorder = computed(() => ((props.noBorder) ? '0' : '0.5px solid #EAEDF4'));
const resizeUrl = computed(() => (props.itemInfo?.thumbnailUrl ? resizeImg(props.itemInfo?.thumbnailUrl, 128) : ''));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`info-card ${props.isTop ? 'info-card-top': ''}`),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.toDetail(__props.itemInfo?.informationId, __props.itemInfo?.weightValue)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["info-title", __props.itemInfo?.hasRead ? 'info-title-read' : ''])
        }, [
          (props.isTop)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(__props.itemInfo?.title), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["minor-info", __props.itemInfo?.hasRead ? 'minor-info-read' : ''])
        }, [
          (__props.itemInfo?.source?.trim())
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(__props.itemInfo?.source?.trim()), 1))
            : _createCommentVNode("", true),
          (__props.itemInfo?.source?.trim())
            ? (_openBlock(), _createElementBlock("span", _hoisted_8))
            : _createCommentVNode("", true),
          _createElementVNode("span", null, _toDisplayString(_unref(publishTimeFormat)(__props.itemInfo?.inputTime)), 1)
        ], 2)
      ]),
      (_unref(resizeUrl))
        ? (_openBlock(), _createBlock(_unref(Image), {
            key: 0,
            src: _unref(resizeUrl),
            class: "info-img",
            fit: "cover"
          }, null, 8, ["src"]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})